module.exports = __webpack_public_path__ + "static/media/ParamResearch.e4e901be.svg";